// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");
let BroadcastSearchResultTimestamp = require("../../common/BroadcastSearchResultTimestamp.bs.js");

function ClientNeedSearchResultTimestamp(props) {
  return JsxRuntime.jsx(BroadcastSearchResultTimestamp.make, {
    updatedAt: props.updatedAt,
    broadcastAt: props.broadcastAt
  });
}

let make = ClientNeedSearchResultTimestamp;

exports.make = make;
/* react/jsx-runtime Not a pure module */
